(function documentRRHHDetailControllerDefinition() {
    'use strict';

    angular.module('DocumentRRHH')
        .controller('DocumentRRHHDetailController', [
            '$filter', '$state', '$scope', '$stateParams', '$translate', 'alerts', 'errorsExtend', 'processService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', 'fileDownloader', '$window',
            function documentRRHHDetailController($filter, $state, $scope, $stateParams, $translate, alerts, errors, processService, fileWorkflowService, auth, configViewService, $q, fileDownloader, $window) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.loadDocument = function () {
                    return processService.getById($stateParams.id).then(function (result) {
                        $scope.document = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.loadConfigView = function () {
                    return configViewService.getById('CPPDocumentRRHH').then(function (result) {
                        $scope.configView = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                }

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId)
                }

                $scope.previewFile = function (item, index) {

                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item, true).then(function (result) {
                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.delete = function () {
                    return $translate(['Warning', 'DocumentDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                processService.delete($stateParams.id).then(function () {
                                    $state.go('document-rrhh-find');
                                }, function (error) {
                                    errors.showError(error);
                                });;
                            }
                        });
                    });
                };

                $scope.edit = function () {
                    processService.setSignProcesses([$scope.document]);
                    $state.go('document-rrhh-sign');
                };

                $scope.retry = function () {
                    return processService.execute($stateParams.id).then(function (result) {
                        errors.showSuccess('ProcessRetryingSuccess');
                        $scope.load();
                    }, function (error) {
                        errors.showError(error);
                        $scope.load();
                    });
                };

                $scope.history = function (proc) {
                    $state.go('process-history', { id: proc.id });
                };

                $scope.loadActions = function (processType, process) {
                    var result = $filter('filter')(processType.groupStates, function (item) {
                        return item.ids.indexOf(process.stateId) > -1;
                    }, true);

                    if (result.length > 0) {
                        $scope.actions = {
                            delete: result[0].delete,
                            edit: result[0].edit,
                            editName: result[0].editName,
                            retry: result[0].retry
                        };
                    }
                };

                $scope.load = function () {
                    $scope.actions = {
                        delete: false,
                        edit: false,
                        editName: 'Edit',
                        retry: false
                    };

                    $scope.userId = auth.getUserId();
                    $scope.writePermission = auth.isInRole('DOCUMENT WRITE');
                    $scope.signPermission = auth.isInRole('DOCUMENT SIGN');
                    $scope.deletePermission = auth.isInRole('DOCUMENT DELETE');
                    $scope.processHistoryPermission = auth.isInRole('DOCUMENT READ');

                    var metadatas = [];

                    $q.all([$scope.loadDocument(), $scope.loadConfigView()]).then(function () {
                        var result = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.document.processTypeId }, true);
                        if (result.length == 0) {
                            $scope.document.metadataValues = metadatas;
                            return;
                        }

                        result[0].metadatas.forEach(function (documentMetadata) {
                            if (documentMetadata.detailCriteria) {
                                var metadataFound = $filter('filter')($scope.document.metadataValues, { systemName: documentMetadata.systemName }, true);

                                var value = null;
                                var desc = null;

                                if (metadataFound.length > 0) {
                                    value = metadataFound[0].value;
                                    desc = metadataFound[0].description;
                                }

                                metadatas.push({
                                    metadataId: documentMetadata.metadataId,
                                    type: documentMetadata.metadataType != null ? documentMetadata.metadataType.toLowerCase() : undefined,
                                    name: documentMetadata.detailCriteria.name,
                                    isVisible: true,
                                    maskOptions: documentMetadata.maskOptions,
                                    systemName: documentMetadata.systemName,
                                    order: documentMetadata.detailCriteria.order,
                                    value: value,
                                    description: desc,
                                    mask: documentMetadata.detailCriteria.mask
                                });
                            }
                        });

                        metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        $scope.document.metadataValues = metadatas;
                        $scope.loadActions(result[0], $scope.document);
                        var item = {};

                        $scope.document.files.forEach(function (file) {
                            item.creationDate = file.creationDate;
                            item.name = file.name;
                            item.size = file.size;
                            item.id = file.id;
                            item.stream = null;
                        });

                        $scope.previewFile(item, 0);
                    });
                };

                $scope.downloadFile = function () {
                    if ($scope.document.files.length < 2) {
                        $scope.document.files.forEach(function (file) {
                            return fileWorkflowService.downloadFile(file.id).then(function (result) {
                                var success = fileDownloader.saveAs(result, file.name);
                                if (!success) {
                                    errors.showError('Api failed');
                                }
                            }, function (error) {
                                if (error.status === 204) {
                                    errors.showWarning('The document has no files');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                    } else {
                        var files = [];

                        $scope.document.files.forEach(function (file) {
                            files.push({ id: file.id, name: file.name });
                        });

                        return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {
                            var success = fileDownloader.saveAs(result.value, $translate.instant('DocumentAllFiles') + '.zip');
                            if (!success) {
                                errors.showError('Api failed');
                            }
                        }, function (error) {
                            if (error.status === 204) {
                                errors.showWarning('The document has no files');
                            } else {
                                errors.showError('Api failed');
                            }
                        });
                    }
                };

                $scope.load();
            }
        ]);
})();
